import type {CreateExtArgs, Extension, ExtensionAPI} from '@wix/document-manager-core'

const EVENTS = {
    PUBLIC_APIS: {
        IS_READY: 'PUBLIC_APIS.IS_READY'
    }
}

const createExtensionAPI = ({dal, eventEmitter}: CreateExtArgs): LifecycleExtApi => ({
    siteAPI: {
        forceUpdate: () => {
            dal.commitTransaction('lifecycleExt')
        }
    },
    publicAPIs: {
        notifyPublicAPIIsReady: () => {
            eventEmitter.emit(EVENTS.PUBLIC_APIS.IS_READY)
        }
    }
})

const createExtension = (): Extension => ({
    name: 'lifecycle',
    createExtensionAPI,
    EVENTS
})

export type LifecycleExtApi = ExtensionAPI & {
    siteAPI: {
        forceUpdate(): void
    }
    publicAPIs: {
        notifyPublicAPIIsReady(): void
    }
}

export {createExtension}
